import { heatList } from "@/mocks/blackdata";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-fill text-secondary-600",
  down: "ri-arrow-down-fill text-foreground-400",
  flat: "ri-arrow-right-fill text-foreground-400",
};

const rankTone = ["bg-primary-600", "bg-primary-500", "bg-accent-500"];

export default function HeatRank() {
  return (
    <section id="rank" className="bg-background-100 mt-10 md:mt-14 scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-3 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {/* 热度榜 */}
          <div className="lg:col-span-2 bg-background-50 border border-background-200 rounded-lg p-3 md:p-5">
            <div className="flex flex-wrap items-center justify-between gap-2 px-1 pb-3">
              <h2 className="flex items-center gap-2 font-heading text-xl md:text-2xl text-foreground-950">
                <span className="inline-flex h-7 w-7 items-center justify-center rounded bg-accent-500 text-background-50">
                  <i className="ri-fire-fill w-4 h-4 flex items-center justify-center"></i>
                </span>
                本周话题热度榜
              </h2>
              <span className="text-[11px] text-foreground-400">热度统计自瓜友讨论 · 每 6 小时刷新</span>
            </div>
            <ol className="divide-y divide-background-200">
              {heatList.map((h) => (
                <li key={h.rank}>
                  <a href="#figure" className="group flex items-center gap-3 py-2.5 px-1">
                    <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-[12px] font-bold text-background-50 ${rankTone[h.rank - 1] ?? "bg-background-300 text-foreground-700"}`}>
                      {h.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-[14px] font-medium text-foreground-900 truncate group-hover:text-primary-700 transition-colors">{h.title}</p>
                      <p className="text-[11px] text-foreground-400">人物：{h.figure}</p>
                    </div>
                    <i className={`${trendIcon[h.trend]} w-4 h-4 flex items-center justify-center shrink-0`}></i>
                    <span className="text-[12px] text-accent-700 font-medium whitespace-nowrap shrink-0">{h.count}</span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* 追更 + 投稿须知 */}
          <div className="flex flex-col gap-4 md:gap-5">
            <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-bell-line w-5 h-5 flex items-center justify-center text-primary-600"></i>
                追更这期事件
              </h3>
              <p className="text-[12px] text-foreground-600 mt-1 leading-relaxed">选择想跟进的分区，动态更新后会集中提醒你。</p>
              <div className="flex flex-wrap gap-2 mt-3">
                {["主播塌房实锤", "网红翻车名单", "直播丑闻录屏", "人物档案"].map((c) => (
                  <button
                    key={c}
                    type="button"
                    className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-[12px] text-foreground-700 hover:border-primary-300 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap"
                  >
                    {c}
                  </button>
                ))}
              </div>
              <a href="#download" className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 text-background-50 px-3 py-2.5 text-sm font-medium hover:bg-primary-700 transition-colors">
                开启追更提醒<i className="ri-notification-3-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-quill-pen-fill w-5 h-5 flex items-center justify-center text-accent-600"></i>
                提供线索 / 投稿
              </h3>
              <ul className="mt-2 flex flex-col gap-1.5 text-[12px] text-foreground-600">
                <li className="flex gap-2"><i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-secondary-600 shrink-0"></i>仅收录带来源、可核对的素材</li>
                <li className="flex gap-2"><i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-secondary-600 shrink-0"></i>聊天记录需提供可交叉的时间戳</li>
                <li className="flex gap-2"><i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-secondary-600 shrink-0"></i>存疑条目会折叠并标注「待验证」</li>
              </ul>
              <a href="#faq" className="mt-3 inline-flex items-center gap-1 text-[13px] text-accent-700 font-medium whitespace-nowrap">
                了解收录规则与投稿流程<i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}